import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "../assets/css/style.module.scss";
import appStore from "../assets/img/signupv2/willow/app-store.svg";
import googlePlay from "../assets/img/signupv2/willow/google-play.svg";
import device from "../assets/img/signupv2/willow/device.svg";
import giftbagIcon from "../assets/img/giftbag.svg";

import {
  setClevertapProfile,
  willow_cancel_downloaded,
  willow_cancel_successful,
  willow_signup_completed,
  willow_signup_downloaded,
} from "../libs/events";
import TcQR from "../assets/img/tc_qr.svg";
import WillowRightSection from "../components/WillowRightSection";
import { countdown } from "../libs/utils";
import { verifyPasswordReset } from "../services/auth";

function WillowSignupSuccess() {
  const [searchParams] = useSearchParams();
  // const type = searchParams.get("type");
  const email = searchParams.get("email");
  const plan = searchParams.get("subscription_plan");
  const flow = searchParams.get("flow");
  const id = searchParams.get("email");
  const token = searchParams.get("token");
  // const action_type = searchParams.get("action_type");

  const [appLinkToken, setAppLinkToken] = useState();
  const [error, setError] = useState(null);

  const countdownRef = useRef();

  useEffect(() => {
    if (email) {
      setClevertapProfile({ email });
      if (flow === "CANCELLATION") {
        willow_cancel_successful({
          email,
          plan,
        });
      } else {
        willow_signup_completed({
          email,
          plan,
        });
      }
    }
  }, [email]);

  useEffect(() => {
    verifyPasswordReset({
      id: id,
      token: token,
      action_type: "SEND_APP_LINK",
    })
      .then((response) => {
        setAppLinkToken(response.app_link_token);
      })
      .catch((error) => {
        if (error?.response?.data?.error?.message == 0) {
          setError("Oops! Something went wrong");
        } else {
          setError(
            error?.response?.data?.error?.message
              ? error?.response?.data?.error?.message
              : error.message
          );
        }
      });
    countdown(1800, countdownRef);
  }, []);

  // useEffect(() => {

  // }, []);

  return (
    <div className={styles.willow}>
      <div className={styles.container}>
        <div className={styles.signupBox}>
          <div className={styles.body}>
            <div className={styles.itemLeft}>
              <div className={styles.screen2}>
                <div className={styles.success}>Success</div>
                <div className={styles.title}>
                  Your cashback has been credited.
                </div>
                <div className={styles.subTitle}>
                  <>
                    Download the Abound app now and login to your account to
                    view your cashback and get an additional $5 welcome bonus.
                  </>
                </div>
                <div className={styles.countdownContainer}>
                  <div className={styles.cdLeftSection}>
                    <img src={giftbagIcon} />
                    $5 welcome bonus
                  </div>
                  <div>
                    Claim in <span ref={countdownRef}>29m 36s</span>
                  </div>
                </div>

                <div className={styles.bottomContainer}>
                  <div className={styles.bottomBox}>
                    <div className={styles.device}>
                      <img src={device} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.itemRight}>
              <WillowRightSection
                appLinkToken={appLinkToken}
                id={email}
                flow={flow}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WillowSignupSuccess;
